// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".van-button{border-radius:8px}.van-badge{border:none}.van-uploader__input-wrapper{width:100%}", ""]);
// Exports
module.exports = exports;
